angular.module('wbControllers').controller 'DocumentController',

['$scope', 'railsResource', 'users'
($scope, $resource, users) ->
    $scope.sender = users.getCurrentUser()
    $scope.state = state = {}

    $scope.categories = [
      { name: 'General Document', value: 'document' },
      { name: 'Identification', value: 'identification'},
      { name: 'Identification Back', value: 'identification_back'},
      { name: 'Bank Statement', value: 'bank_statement'},
      { name: 'Bank Document', value: 'bank_info'},
      { name: 'Credential', value: 'credential'},
    ]

    $scope.resetForm = ->
      $scope.state = state = {}
      state.error = state.success = state.uploading = state.sending = false
      $scope.category = $scope.categories[0].value
      $scope.message = undefined

    $scope.upload = (form, sendToClient) ->
      state.message = 'All fields must be filled out correctly before continuing' if form.$invalid
      return unless (state.sending or state.uploading) is false and form.$valid
      state.sending = sendToClient
      state.uploading = !sendToClient
      state.message = null
      $scope.uploader.category = $scope.category
      $scope.uploader.message = $scope.message || ''
      $scope.uploader.sendToClient = sendToClient
      $scope.uploader.sendToAdvisor = if $scope.sendToAdvisor then true else false
      $scope.uploader.userVisible = sendToClient
      $scope.uploader.title = $scope.title
      $scope.uploader.upload()
      $scope.documentDialog.hide()

    $scope.$on('upload_request', (event, uploader) ->
      $scope.resetForm()
      $scope.title = uploader.file.name
      $scope.sendToAdvisor = true
      $scope.uploader = uploader
      $scope.documentDialog.show()
      $scope.$apply()
    )
]
